import { useQuery } from 'react-query';
import { Grid, MenuItem, TextField } from '@mui/material';
import { IDropdownResponse } from '../../../models';
import { formatInputPhoneNumber, alphaSort } from '../../../helpers';
import { SMBSelect, StatesDropdown } from '../../../components';
import { getAdminLookupAttorneyOffices } from '../../../fetch/lookups/admin-portal';

export const AttorneyFields = ({
  setFieldValue,
  isFormDisabled,
  values,
  handleBlur,
  touched,
  errors
}) => {
  const { isLoading: isLoadingAttorneys, data: attorneys } = useQuery<IDropdownResponse[], Error>(
    ['attorney-offices'],
    () => getAdminLookupAttorneyOffices()
  );

  return (
    <>
      <Grid item xs={12} sm={6}>
        <SMBSelect
          variant="outlined"
          disabled={isLoadingAttorneys}
          name="attorneyOfficeId"
          required
          label="Attorney Office"
          id="attorneyOfficeId"
          handleClear={() => setFieldValue('attorneyOfficeId', '')}
          value={values.attorneyOfficeId}
          onChange={({ target: { value } }) => {
            setFieldValue('attorneyOfficeId', value as string);
          }}
        >
          {attorneys &&
            alphaSort(attorneys, 'description').map((office: IDropdownResponse, index) => {
              return (
                <MenuItem key={`${index}`} value={office.value}>
                  {office.description}
                </MenuItem>
              );
            })}
        </SMBSelect>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          variant="outlined"
          autoComplete="nope"
          label="First Name"
          name="firstName"
          value={values.firstName}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          inputProps={{
            'data-lpignore': 'true'
          }}
          error={touched.firstName && errors && errors.firstName ? true : false}
          helperText={touched.firstName && errors && errors.firstName}
          onChange={e => setFieldValue('firstName', e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          variant="outlined"
          autoComplete="nope"
          label="Last Name"
          name="lastName"
          inputProps={{
            'data-lpignore': 'true'
          }}
          value={values.lastName}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          error={touched.lastName && errors && errors.lastName ? true : false}
          helperText={touched.lastName && errors && errors.lastName}
          onChange={e => setFieldValue('lastName', e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          onChange={e => setFieldValue('email', e.target.value)}
          error={touched.email && errors && errors.email ? true : false}
          helperText={touched.email && errors && errors.email}
          fullWidth={true}
          id="email"
          name="email"
          label="Email (Username)"
          size="small"
          onBlur={handleBlur}
          required={true}
          autoComplete="off"
          value={values.email}
          disabled={isFormDisabled}
          inputProps={{
            'data-lpignore': true // Last Pass disable auto-fill
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="Phone Number"
          name="phone"
          value={values.phoneNumber}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          onChange={e => {
            setFieldValue('phoneNumber', formatInputPhoneNumber(e.target.value));
          }}
          error={Boolean(touched.phoneNumber && errors.phoneNumber)}
          helperText={touched.phoneNumber && errors.phoneNumber}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="Address Line 1"
          name="address"
          inputProps={{
            'data-lpignore': 'true'
          }}
          value={values.address}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          error={touched.address && errors && errors.address ? true : false}
          helperText={touched.address && errors && errors.address}
          onChange={e => setFieldValue('address', e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="Address Line 2"
          name="address2"
          inputProps={{
            'data-lpignore': 'true'
          }}
          value={values.address2}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          error={touched.address2 && errors && errors.address2 ? true : false}
          helperText={touched.address2 && errors && errors.address2}
          onChange={e => setFieldValue('address2', e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="City"
          name="city"
          inputProps={{
            'data-lpignore': 'true'
          }}
          value={values.city}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          error={touched.city && errors && errors.city ? true : false}
          helperText={touched.city && errors && errors.city}
          onChange={e => setFieldValue('city', e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <StatesDropdown
          value={values.state}
          handleChange={value => {
            setFieldValue('state', value as string);
          }}
          isAdminPortal={true}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          fullWidth
          variant="outlined"
          autoComplete="nope"
          label="ZIP"
          name="zip"
          inputProps={{
            'data-lpignore': 'true'
          }}
          value={values.zip}
          disabled={isFormDisabled}
          onBlur={handleBlur}
          size="small"
          error={touched.zip && errors && errors.zip ? true : false}
          helperText={touched.zip && errors && errors.zip}
          onChange={e => setFieldValue('zip', e.target.value)}
        />
      </Grid>
    </>
  );
};
